import { FC } from 'react';

type Props = {
  mastheadImageUrl: string;
}

const MastheadImage:FC<Props> = ({
  // Props
  mastheadImageUrl
}) => {
  return (
    <div  
      className="
        flex-shrink-0
        shadow-lg
        rounded-br-lg rounded-bl-lg
        overflow-hidden
      "
      style={{ height: 168 }}
    >
      <img className="h-full w-full object-cover" src={mastheadImageUrl} alt="masthead" />
    </div>
  )
}

export default MastheadImage;
